import * as React from 'react';

export const APP_CONTEXT = {
  shouldAutoScroll: true
};

export default React.createContext(APP_CONTEXT);
